module.exports = __webpack_public_path__ + "static/media/download.b3070109.gif";